import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { onMounted, ref, computed, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleOperationOfficeAutoComplete',
  props: {
    modelValue: {},
    managementOffice: {},
    errorMessages: {},
    selectFirstIfOnlyOne: { type: Boolean },
    initialOperationId: {},
    clearable: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    filterParams: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit;

const items = ref<getOperationOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteOperationOffices()
    .then((data) => {
      setItems(data);
      setModelValue();
    });
});

watch(
  () => props.initialOperationId,
  () => {
    setModelValue();
  }
);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  let filteredItems = items.value;
  if (props.initialOperationId) {
    modelValue.value = filteredItems.filter((item) => {
      return item.id === props.initialOperationId
    })[0];
  }
}

function setItems(operationOffices: getOperationOffice[]) {
  if (!props.filterParams) {
    return items.value = operationOffices;
  }

  let filteredItems: getOperationOffice[] = [];
  if (Object.keys(props.filterParams).indexOf('tenko_type') !== -1) {
    operationOffices.forEach((operationOffice: getOperationOffice) => {
      if (operationOffice.tenko_type && props.filterParams?.tenko_type.includes(operationOffice.tenko_type)) {
        filteredItems.push(operationOffice);
      }
    })
  }

  items.value = filteredItems;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "運営会社",
    itemName: "name",
    items: items.value,
    "initial-item-id": props.initialOperationId,
    "management-office": props.managementOffice,
    errorMessages: props.errorMessages,
    selectFirstIfOnlyOne: "",
    clearable: props.clearable,
    readonly: props.readonly,
    disabled: props.disabled
  }, null, 8, ["modelValue", "items", "initial-item-id", "management-office", "errorMessages", "clearable", "readonly", "disabled"]))
}
}

})